import React, {Fragment, useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Button from 'react-bootstrap/Button';
import {updateProduction, getProductOptions, setUpdateProductionId} from "../../actions/production";
import Select from 'react-select'
import {Form} from "react-bootstrap";
import {getParams, getSelectedOption} from "../../utils/hooks/getParams";
import moment from "moment";
import ButtonLoader from "../layout/ButtonLoader";
import Modal from "react-bootstrap/Modal";
import {clearErrors} from "../../actions/client";
import useActiveFirm from '../../hooks/useActiveFirm';

const ProductionUpdateForm = ({
                                  error,
                                  update_production,
                                  handleClose,
                                  loading,
                                  product_options,
                                  updateProduction,
                                  getProductOptions,
                              }) => {
    const { firmId } = useActiveFirm();
    const formRef = useRef();

    const [productOptions, setProductOptions] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState({label: 'Tanlang', value: ''});

    const defaultValues = {
        firm_id: '',
        product_id: '',
        quantity: '',
        date: '',
    };
    const [inputs, setInputs] = useState(defaultValues);
    const [errors, setErrors] = useState({});


    useEffect(() => {
        if (update_production){
            const productionFirmId = update_production.warehouse?.firm_id || firmId;
            setInputs({
                product_id: update_production.product_id,
                firm_id: productionFirmId,
                quantity: parseInt(update_production.quantity),
                date: update_production.date,
            });
            // Load product options for the firm
            if (productionFirmId) {
                getProductOptions({firm_id: productionFirmId});
            }
        } else if (firmId) {
            // If no production is being updated, use global active firm
            setInputs(prev => ({ ...prev, firm_id: firmId }));
            getProductOptions({firm_id: firmId});
        }
    }, [update_production, firmId, getProductOptions]);
    
    // Ensure firm_id is always set from global active firm when not updating
    useEffect(() => {
        if (firmId && !update_production && inputs.firm_id !== firmId) {
            setInputs(prev => ({ ...prev, firm_id: firmId }));
            getProductOptions({firm_id: firmId});
        }
    }, [firmId, update_production, getProductOptions, inputs.firm_id]);

    useEffect(() => {
        if (update_production && update_production.hasOwnProperty('product_id')){
            setSelectedProduct(getSelectedOption(update_production.product_id, productOptions))
        }
    }, [productOptions]);


    useEffect(() => {
        let options = [];
        product_options.forEach((item) => options.push({
            label: item.name,
            value: item.id
        }));
        setProductOptions(options);
    }, [product_options]);

    const handleChange = e => {
        if (e.target.name === 'quantity' && parseFloat(e.target.value) < 0) {
            e.target.value = Number(e.target.value) * -1;
        }
        setErrors({});
        setInputs(prevState => ({...prevState, [e.target.name]: e.target.value}));
    }
    const handleSelect = (data, type) => {
        // Firm selection is handled by global firm switcher, not here
        setErrors({});
        setInputs(prevState => ({...prevState, [type.name]: data.value}))
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (await updateProduction(update_production.id, inputs, getParams(true))) {
            setInputs(defaultValues);
            onClose();
        }
    };
    useEffect(() => {

        if (loading === false) {
            if (error) {
                const errorsItems = error?.errors;
                let errorObject = {};
                if (error.hasOwnProperty('errors')) {
                    Object.keys(error.errors).forEach((item) => errorObject[item] = errorsItems[item][0]);
                }
                setErrors(errorObject);

            } else {
                setErrors({});
                setInputs(defaultValues);
            }
        }
    }, [error]);

    const onClose = () => {
        setUpdateProductionId(null);
        clearErrors();
        setInputs(defaultValues);
        setErrors({});
        handleClose();
    };


    return (
        <Fragment>
            <Modal show={true} onHide={onClose}>
                <Modal.Header closeButton className="bg-light">
                    <Modal.Title>ishlab chiqarish ni tahrirlash</Modal.Title>
                </Modal.Header>
                <Modal.Body className="pt-3 pb-4 mx-3">

                    <Form onSubmit={handleSubmit} ref={formRef}>

                        <div className="mb-3">
                        </div>

                        <div className="mb-2">
                            <label htmlFor="product_id">Mahsulot</label>
                            <Select
                                name={'product_id'}
                                options={productOptions}
                                value={selectedProduct}
                                onChange={handleSelect}
                                defaultValue={{label: 'Tanlang', value: ''}}
                            />
                            <div className="error">
                                {errors?.product_id}
                            </div>
                        </div>

                        {/*<div className="mb-2">*/}
                        {/*    <label htmlFor="warehouse_id">Mahsulot sklad</label>*/}
                        {/*    <Select*/}
                        {/*        name={'warehouse_id'}*/}
                        {/*        options={warehouseOptions}*/}
                        {/*        value={getSelectedOption(inputs?.warehouse_id || '', warehouseOptions)}*/}
                        {/*        onChange={handleSelect}*/}
                        {/*        defaultValue={{label: 'Tanlang', value: ''}}*/}
                        {/*    />*/}
                        {/*    <div className="error">*/}
                        {/*        {errors?.warehouse_id}*/}
                        {/*    </div>*/}
                        {/*</div>*/}

                        <div className="mb-2">
                            <label htmlFor="quantity">Miqdori</label>
                            <input
                                name="quantity"
                                className={'form-control'}
                                value={inputs?.quantity || ''}
                                type="text"
                                min={1}
                                placeholder={1000}
                                onChange={handleChange}
                                required
                            />
                            <div className="error">
                                {errors?.quantity}
                            </div>
                        </div>

                        <div className="mb-3">
                            <label htmlFor="date">Sana</label>
                            <input
                                name="date"
                                className={'form-control'}
                                type="date"
                                value={inputs?.date || ''}
                                placeholder={'kiriting'}
                                onChange={handleChange}
                                max={moment().format('YYYY-MM-DD')}
                                // onKeyUp={e => e.target.oldValue = e.target.value}
                            />

                            <div className="error">
                                {errors?.date}
                            </div>
                        </div>


                        <div className="d-flex gap-2">
                            <Button className="w-50" variant="secondary" type="button" onClick={onClose}>Bekor
                                qilish</Button>
                            <Button className="w-50" variant="primary" type="submit">
                                Saqlash
                                {loading && <ButtonLoader/>}
                            </Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        </Fragment>
    );
};

ProductionUpdateForm.propTypes = {
    updateProduction: PropTypes.func.isRequired,
    getProductOptions: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    production: state.production,
    update_production: state.production.update_production,
    error: state.production.error,
    loading: state.production.loading,
    product_units: state.production.product_units,
    product_options: state.production.product_options,
    warehouse_options: state.production.warehouse_options,
});


export default connect(mapStateToProps, {
    updateProduction,
    getProductOptions
})(ProductionUpdateForm);
